export const LoadingView = () => <div>Loading</div>